import { render } from "./PermissionForm.vue?vue&type=template&id=15675874&scoped=true&ts=true"
import script from "./PermissionForm.vue?vue&type=script&lang=ts"
export * from "./PermissionForm.vue?vue&type=script&lang=ts"

import "./PermissionForm.vue?vue&type=style&index=0&id=15675874&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15675874"]])

export default __exports__